import type { ReactNode } from 'react'

import styles from './HelpPanelCard.module.scss'

interface IHelpPanelCardProps {
  icon: ReactNode
  title: ReactNode
  text: ReactNode
  disabled?: boolean
  /** Left out when a popup opens from the card on its own. */
  onClick?: () => void
}

/** One of the help cards that open the panel: a blue disc, a title and a line on what it holds. */
export const HelpPanelCard = ({
  icon,
  title,
  text,
  disabled = false,
  onClick,
}: IHelpPanelCardProps) => (
  <button type="button" className={styles.root} disabled={disabled} onClick={onClick}>
    <span className={styles.icon}>{icon}</span>
    <span className={styles.title}>{title}</span>
    <span className={styles.text}>{text}</span>
  </button>
)

HelpPanelCard.displayName = 'HelpPanelCard'
